/**
 * MV (mail-only team visibility): the one rule every mail surface uses to decide whether a
 * comm carries a team restriction worth marking, and under which name.
 *
 * A blank name is NO restriction: a badge with an icon and nothing beside it claims a
 * restriction it cannot name. Blank means "nothing visible in it", not "empty": String.trim()
 * drops whitespace but keeps FORMAT characters (U+200B zero-width space, U+2060 word joiner,
 * the direction marks, the soft hyphen), and a name made of those alone renders that same
 * wordless badge. The mappers carry the wire value verbatim, so that call lives here rather
 * than once per surface.
 */
export function mailTeamMarkerName(raw: string | null | undefined): string | null {
  const name = raw?.trim() ?? '';
  return /[^\p{Cf}\s]/u.test(name) ? name : null;
}

/**
 * MV: the hover text for the team marker, for a name mailTeamMarkerName already vouched for.
 * A restriction to several teams is an INTERSECTION (a reader must be in all of them), so the
 * several-team wording must not read as a list of alternatives.
 *
 * The api sends the restricting teams as ONE ', '-joined string, never an array, so the count
 * is read back by splitting on that separator: a team name that itself contains ', ' is
 * miscounted here, which is accepted rather than changing the wire.
 */
export function mailTeamTooltip(team: string): string {
  return team.split(', ').length > 1
    ? `Nur sichtbar für Mitglieder aller Teams: ${team}`
    : `Nur sichtbar für Mitglieder des Teams ${team}`;
}
